import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/compare
 * @alias remove
 *
 * @description
 * Очистка сравнения
 *
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.compare.clear()
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function() {
  return fetchJQueryAdapter('/front_api/compares/clear.json',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }
  );
}
